import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';
import { SwitchCorporateDialogComponent } from '../switch-corporate-dialog/switch-corporate-dialog.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-locations-dropdown-dialog',
  templateUrl: './locations-dropdown-dialog.component.html',
  styleUrls: ['./locations-dropdown-dialog.component.scss'],
  providers: [DialogService],
})
export class LocationsDropdownDialogComponent implements OnInit {
  currentShopId: string = '';
  defaultShopId: string = '';
  isProcessing: boolean = false;
  companyLocations: any[] = [];
  corporateId: string;
  isMarkPsDashboard = false;
  isMultiLocationEnabled = false;
  appliedStoreList: any = [];
  hasMultiLocationAccess: boolean = false;
  constructor(
    private helperService: HelperService,
    private dialogService: DialogService,
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
  ) {}

  ngOnInit() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.isMultiLocationEnabled = isMultiLocationEnabled;
     const {hasMultiLocationAccess, partList, currentShopId} = this.dialogConfig.data;
     this.appliedStoreList = partList;
     this.hasMultiLocationAccess = hasMultiLocationAccess;
     this.currentShopId = currentShopId;
    this.companyLocations = this.dataService.shopAccessesList;
    this.getCompanyLocation();
  }

  getCompanyLocation() {
    this.companyLocations = this.companyLocations.map((location: any) => {
      const isDisabled = this.appliedStoreList.some((store) => store._id === location._id && store.name !== 'Company');
    
      return {
        ...location,
        disabled: isDisabled,
      };
    });
    
    if (!this.hasMultiLocationAccess) {
      this.companyLocations = this.companyLocations.filter(location => location._id === this.currentShopId);
    }
  }

  handleChange(currentShopId: string) {
    this.currentShopId = currentShopId;
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  handleSave() {
    this.dynamicDialogRef.close({ isSuccess: true, data: this.currentShopId });
  }
}
